import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import Fade from 'react-reveal/Fade';
import Flash from 'react-reveal/Flash';

import { setCookie, getCookie } from '../utils/cookie_utils.js'

import Navbar from '../components/Navbar'
import OpenSlideShow from '../components/OpenSlideShow'
import LogoWall from '../components/LogoWall'
import Footer from '../components/Footer'

import '../css/MainPage.css';
import '../css/NumberAnimation.css';

class MainPage extends Component {
  constructor(props) {
    var lang = "zh"
    if (getCookie("lang") !== "") {
      lang = getCookie("lang")
      console.log("lang in")
    }
    console.log("MainPage after lang:", lang, getCookie("lang"))

    super(props);
    this.state = {
      lang: lang
    }

    this.general_switch_page = this.general_switch_page.bind(this)
    this.update_lang = this.update_lang.bind(this)
  }

  update_lang(current_lang) {
    this.setState({
      lang: current_lang
    }, () => {
      console.log(this.state.lang)
    })
  }

  general_switch_page(path, data) {
    if (path !== "/MainPage" || path !== "/") {
      setCookie("lang", this.state.lang)
      window.location.href = path + "?page=" + data
    }
    else {
      // pass
    }
  }


  render() {

        return (
          <div className={this.state.lang} >
            <Navbar lang={this.state.lang} updateLangFunc={this.update_lang} />
            <OpenSlideShow lang={this.state.lang} switchPageFunc={this.general_switch_page} />
            <MainPageSection1 lang={this.state.lang} switchPageFunc={this.general_switch_page}/>
            <MainPageSection2 lang={this.state.lang} switchPageFunc={this.general_switch_page}/>
            <MainPageSection3 lang={this.state.lang} switchPageFunc={this.general_switch_page}/>
            <LogoWall />
            <Footer lang={this.state.lang} general_switch_page={this.general_switch_page}/>
          </div>
        ) 
  }

}

export default MainPage;

class MainPageSection1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      title: {
        "zh": "探索NEXUNI的機器人",
        "en": "Explore NEXUNI's Robots",
        "ja": "NEXUNI のロボットを探索する"
      },
      search_btn: {
        "zh": "開始探索",
        "en": "Start Exploring",
        "ja": "詳しくはこちら"
      },
      content: [{
        delay: "400",
        title: {
          "zh": "AI保全巡邏機器狗", 
          "en": "AI Security Patrol Robot Dog", 
          "ja": "AI警備パトロールロボット犬"
        },
        content: {
          "zh": "Nexuni AI 巡邏機器狗專為智慧保全設計，支援各種地形的自主巡邏與即時異常偵測，致力提升城市安全。",
          "en": "Nexuni’s AI patrol robot dog provides all-terrain autonomous security, using AI to detect and report anomalies in real-time to enhance urban safety.",
          "ja": "NexuniのAI巡回ロボット犬は全地形対応の自律警備を実現。AIで異常をリアルタイム検知し、都市の安全性を高めます。"
        }
      },
      {
        delay: "600",
        title: {
          "zh": "智慧焊接機器人", 
          "en": "Intelligent Welding Robot", 
          "ja": "スマート溶接ロボット"
        },
        content: {
          "zh": "Nexuni 智慧焊接機器人結合雷射掃描與協作手臂，自動修正工件誤差，免治具、免人工校正。設定時間減少 80%，效率提升 50%，一般人即可上手，降低對專業焊工依賴，實現高精度自動化焊接。",
          "en": "Nexuni's intelligent welding robot integrates laser scanning and a collaborative robotic arm to automatically correct workpiece misalignments—no jigs or manual calibration required. It reduces setup time by 80% and increases efficiency by 50%. Easy to operate by general staff, it reduces reliance on skilled welders while delivering high-precision automated welding.",
          "ja": "Nexuni のスマート溶接ロボットは、レーザースキャンと協働ロボットアームを組み合わせて、ワークの誤差を自動補正します。治具や手動校正は不要で、設定時間を 80% 短縮し、作業効率を 50% 向上させます。専門的なスキルがなくても操作可能で、高精度な自動溶接を実現します。"
        }
      },
      {
        delay: "800",
        title: {
          "zh": "客製化AI機器人自動化", 
          "en": "Customized AI Robotic Automation", 
          "ja": "カスタマイズ可能な AI ロボット自動化"
        },
        content: {
          "zh": "Nexuni 提供量身打造的 AI 機器人解決方案，協助企業提升重複任務效率。無論是半導體精密機械手臂，或生技工廠的協作式機器人，我們皆能依據需求開發高效、穩定的機器人自動化。",
          "en": "Nexuni offers customized AI robotic solutions to help businesses improve the efficiency of repetitive tasks. From precision robotic arms in semiconductor manufacturing to collaborative robots in biotech factories, we develop reliable and high-performance automation tailored to your needs.",
          "ja": "Nexuni は、反復作業の効率向上を支援するため、企業向けにカスタマイズされた AI ロボットソリューションを提供しています。半導体製造の精密ロボットアームから、バイオテクノロジー工場での協働ロボットまで、ニーズに応じた高性能かつ安定した自動化を実現します。"
        }
      }
      ]
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  render() {

        return (
          <div className="v2_mainpage_section1">
          
            <div className="v2_word_section">

              <Fade duration="1000" delay="200">
                <p className="v2_section_num">01 DISCOVER NEXUNI'S ROBOTS</p>
                <h1>{this.state.title[this.state.lang]}</h1>
              </Fade>

              {this.state.content.map((item, index) => 
              <Fade duration="1000" delay={item.delay}>
                <div className="v2_section_content">
                  <h2>{item.title[this.state.lang]}</h2>
                  <p>{item.content[this.state.lang]}</p>
                </div>
                {index === this.state.content.length -1 ? <></> : <hr />}
              </Fade>)}
            </div>
            <Fade duration="1000" delay="1000">
              <div className="v2_img_section" onClick={() => this.props.switchPageFunc("/TechPage", "collie")}>
                <img src="/assets/robot_group.png" />
                <h1>{this.state.search_btn[this.state.lang]}</h1>
                <button className="v2_explore_btn">></button>
              </div>
            </Fade>
          </div>
        ) 
  }

}





class MainPageSection3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      title: {
        "zh": "與NEXUNI合作導入機器人自動化",
        "en": "Partner with NEXUNI to bring robots to your business",
        "ja": "NEXUNI と連携してロボット自動化を導入"
      },
      search_btn: {
         "en": "Start Cooperation",
          "zh": "開始合作",
          "ja": "協力を開始する"
      },
      content: [{
        delay: "600",
        title: {
          "zh": "從 Nexuni 型錄挑選適合的 AI 機器人自動化", 
          "en": "Select the right AI robotic automation solution from Nexuni's catalog", 
          "ja": "Nexuni カタログから最適な AI ロボット自動化ソリューションを選定"
        },
          content: {
          "zh": "Nexuni 提供多元產品，包括焊接機器人、清潔機器人、智慧保全與停車管理等。企業可依據實際需求彈性組合，打造最合適的自動化方案，提升營運效率與效益。",
          "en": "When selecting an AI automation system for your business, you can choose from a variety of solutions offered by Nexuni, including smart parking, smart facility management, AI robotic automation systems, etc. Based on your specific needs, these solutions can be flexibly matched and combined to ensure they meet your business's specific requirements and goals to the fullest.",
          "ja": "あなたのビジネスのAI自動化システムを選ぶ際、Nexuniが提供するスマートパーキング、スマート施設管理、AIロボット自動化システムなど、多様な解決策の中から選ぶことができます。これらのソリューションは、あなたの具体的なニーズに基づいて、マッチングと組み合わせが可能で、ビジネスの特定の要件と目標を最大限に満たすことができます。"
        }
      },
      {
        delay: "800",
        title: {
          "zh": "共同合作開發AI自動化系統解決您企業獨特的痛點", 
          "en": "Partner with Nexuni to build custom AI automation for your business needs",
          "ja": "ビジネスの独自の課題に対応するためにAI自動化システムを共同開発します。"},
          content: {
          "zh": "企業常面臨獨特的運營挑戰，Nexuni可與客戶共同合作，開發專屬的AI自動化系統來解決這些痛點。透過這樣的合作，我們可以精準地對應您的特定需求，打造出符合您企業獨有需求的高效解決方案。",
          "en": "Enterprises often face unique operational challenges, and Nexuni can collaborate with clients to develop customized AI automation systems to address these pain points. Through such collaborations, we can precisely meet your specific needs, creating efficient solutions tailored to the unique requirements of your business.",
          "ja": "企業はしばしば独自の運営上の課題に直面しており、Nexuniはクライアントと協力して、これらの課題に対処するためのカスタムメイドのAI自動化システムを開発することができます。このような協力により、我々はあなたの特定のニーズに正確に対応し、あなたのビジネスのユニークな要求に合わせた効率的な解決策を創り出すことができます。"
        }
      }
      ]
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  render() {

        return (
          <div className="v2_mainpage_section2">

            <Fade duration="1000" delay="200">
              <div className="v2_img_section">
                <img src="/assets/mainpage_home3.webp" />
              </div>
            </Fade>
          
            <div className="v2_word_section">

              <Fade duration="1000" delay="400">
                <p className="v2_section_num">03 YOUR JOURNEY WITH NEXUNI</p>
                <h1>{this.state.title[this.state.lang]}</h1>
              </Fade>

              <div className="v2_sub_word_section">
              {this.state.content.map((item, index) => 
                <Fade duration="1000" delay={item.delay}>
                  <div className="v2_section_content">
                    <h2>{item.title[this.state.lang]}</h2>
                    <p>{item.content[this.state.lang]}</p>
                  </div>
                </Fade>
                )}
                

              </div>

              <Fade duration="1000" delay="1000">
                <div className="v2_explore_btn_holder" onClick={() => this.props.switchPageFunc("/GeneralPage", "colab_flow")}>
                  <button className="v2_explore_btn">></button>
                  <p>{this.state.search_btn[this.state.lang]}</p>
                </div>
              </Fade>
            </div>
          </div>
        ) 
  }

}

class MainPageSection2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      title: {
        "zh": "NEXUNI的AI自動化方案",
        "en": "NEXUNI's AI Automation Solutions",
        "ja": "NEXUNI の AI 自動化ソリューション"
      },
      content: [{
        delay: "400",
        title: {
          "zh": "AI智慧停車", 
          "en": "AI Smart Parking", 
          "ja": "AI スマート駐車"
        },
          content: {
            "zh": "Nexuni 的智慧停車解決方案已應用於超過 30 個停車場、3000 多個車位，涵蓋 AI 車牌辨識、車位在席偵測、智慧路邊開單等系統。這些技術大幅提升停車效率，提供更便捷、準確的管理與用戶體驗，推動停車場智慧化升級。",
            "en": "Nexuni’s smart parking solution has been implemented in over 30 parking lots and 3,000 spaces, covering AI license plate recognition, real-time occupancy detection, and smart roadside ticketing. These technologies greatly improve parking efficiency, offering more convenient and accurate management and a better user experience, accelerating the transformation toward smart parking.",
            "ja": "Nexuni のスマート駐車ソリューションは、30 以上の駐車場と 3,000 台以上の駐車スペースに導入されており、AI ナンバープレート認識、駐車スペース在席検知、スマート路上課金システムを備えています。これらの技術により、駐車効率が大幅に向上し、管理の利便性と精度、ユーザー体験が強化され、スマート駐車への進化を加速します。"
          }
      },
      {
        delay: "600",
        title: {
          "zh": "AI智慧設施管理", 
          "en": "AI Smart Facility Management", 
          "ja": "AI スマート施設管理"
        },
          content: {
            "zh": "Nexuni 的 AI 設施管理已成功部署於新加坡的 13 座工廠與 14 間智慧廁所，整合虛擬巡邏、數位圍籬、人臉門禁與 AIoT 廁所管理技術。系統全面提升安全性與管理效率，助力設施自動化與現代化。",
            "en": "Nexuni’s AI facility management solution has been successfully deployed in 13 factories and 14 smart restrooms in Singapore. It integrates virtual patrols, digital fencing, facial recognition access control, and AIoT-based restroom management. The system significantly improves safety and operational efficiency, promoting automation and modernization across facilities.",
            "ja": "Nexuni の AI 施設管理ソリューションは、シンガポールの 13 工場と 14 のスマートトイレに導入されています。仮想巡回、デジタルフェンス、顔認証入退室管理、AIoT トイレ管理を統合し、安全性と管理効率を大幅に向上させ、施設の自動化と近代化を実現します。"
          }
      },
      {
        delay: "800",
        title: {
          "zh": "客製化AI自動化開發", 
          "en": "Custom AI Automation Development", 
          "ja": "カスタマイズ AI 自動化開発"
        },
          content: {
            "zh": "Nexuni 已成功為日本、德國、新加坡、美國等地的企業提供專屬 AI 自動化設備開發服務。我們具備豐富經驗，能依據需求量身打造解決方案。歡迎聯絡了解更多案例，探討專屬系統開發機會。",
            "en": "Nexuni has provided custom AI automation development services for companies in Japan, Germany, Singapore, the United States, and other regions. With extensive experience, we tailor solutions to meet specific needs. Contact us to learn more about case studies and explore opportunities for custom system development.",
            "ja": "Nexuni は、日本、ドイツ、シンガポール、アメリカなど各国の企業に対し、カスタム AI 自動化開発サービスを提供してきました。豊富な経験を活かし、それぞれのニーズに合わせた最適なソリューションを提供しています。導入事例の詳細やカスタムシステム開発のご相談については、お気軽にお問い合わせください。"
          }
      }
      ],
      num_content: [{
        upto: 30,
        num_id: "num1",
        extra_class: " v2_three_digit",
        title: {
          "zh": "30+個停車場",
          "en": "30+ Parking Lots",
          "ja": "30以上の駐車場"
        }
      },
      {
        upto: 3000,
        num_id: "num2",
        extra_class: " v2_five_digit",
        title: {
          "zh": "管理3000+個車格",
          "en": "Managing 3000+ Parking",
          "ja": "3000以上の駐車スペース管理"
        }
      },
      {
        upto: 13,
        num_id: "num3",
        extra_class: " v2_three_digit",
        title: {
          "zh": "13座新加坡工廠",
          "en": "13 Singapore Factories",
          "ja": "シンガポールの13の工場"
        }
      },
      {
        upto: 14,
        num_id: "num4",
        extra_class: " v2_three_digit",
        title: {
          "zh": "14個智慧廁所",
          "en": "14 Smart Toilets",
          "ja": "14つのスマートトイレ"
        }
      }
      ]
    }


    this.counts = setInterval(this.updatedNumber);

    this.updatedNumber = this.updatedNumber.bind(this);
  }

  updatedNumber(_id, upto) {
    if (_id) {
      let obj = document.getElementById(_id);
      console.log("id: ", _id, upto)
      // count.innerHTML = --upto+1;
      // if (upto === 0) {
      //     clearInterval(this.counts);
      // }

      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / 1000, 1);
        obj.innerHTML = Math.floor(progress * (upto - 0) + 0);
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
      }
      
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  render() {

        return (
          <div className="v2_mainpage_section3">

            <Fade duration="1000" delay="1000">
              <div className="v2_number_section">

                {this.state.num_content.map((item, index) => 
                  <div className="v2_number_word_holder">
                    <hr />
                    <h2 className="v2_number_title">{item.title[this.state.lang]}</h2>
                    <div className={"v2_large_number"+item.extra_class}><span id={item.num_id} onMouseEnter={() => this.updatedNumber(item.num_id, item.upto)}>{item.upto}</span>+</div>
                  </div>
                )}

              </div>
            </Fade>
          
            <div className="v2_word_section">

              <Fade duration="1000" delay="200">
                <p className="v2_section_num">02 NEXUNI'S AUTOMATION SYSTEMS</p>
                <h1>{this.state.title[this.state.lang]}</h1>
              </Fade>

              {this.state.content.map((item, index) => 
              <Fade duration="1000" delay={item.delay}>
                <div className="v2_section_content">
                  <h2>{item.title[this.state.lang]}</h2>
                  <p>{item.content[this.state.lang]}</p>
                </div>
                {index === this.state.content.length -1 ? <></> : <hr />}
              </Fade>)}

            </div>
            
            
          </div>
        ) 
  }

}

